import React from 'react';

import { TrackingStatus, TrackingStatusEnum } from '@ael/core-api';
import classNames from 'classnames';

import './MenuContentItemLabel.scss';

interface MenuContentItemLabelProps {
  title?: string;
  isGrandChild?: boolean;
  onClick?: () => void;
  hideConnectingLines?: boolean;
  isLocked?: boolean;
  isActive?: boolean;
  trackingStatus?: TrackingStatus;
  noWrap?: boolean;
  outsideMenu?: boolean;
}

export const MenuContentItemLabel: React.FC<MenuContentItemLabelProps> = ({
  title,
  isLocked,
  trackingStatus,
  isActive,
  isGrandChild,
  onClick,
  hideConnectingLines,
  noWrap,
  outsideMenu,
}) => (
  <div
    className={classNames('menu-content-item-label', {
      'menu-content-item-label--locked': isLocked,
    })}
    onClick={onClick}
  >
    <div
      className={classNames('menu-content-item-label__indicator', {
        'menu-content-item-label__indicator-grandchild': isGrandChild,
        'menu-content-item-label__indicator--completed': trackingStatus === TrackingStatusEnum.Completed,
        'menu-content-item-label__indicator--in-progress': trackingStatus === TrackingStatusEnum.InProgress,
        'menu-content-item-label__indicator--active': isActive,
        'menu-content-item-label__indicator--no-lines': hideConnectingLines,
        'menu-content-item-label__indicator--outside-menu': outsideMenu,
      })}
    />
    <div
      className={classNames('menu-content-item-label__title', { 'menu-content-item-label__title--no-wrap': noWrap })}
    >
      {title}
    </div>
  </div>
);
